<div class="mb-5" [style]="makeStyle()">
  <div class="row text-center" style="padding-top: 150px">
    <div class="col col-lg-8">
      <!-- <button type="text" class="btn btn-primary w-50" routerLink="/dashboard">Accedi a {{ content }}</button> -->
    </div>
  </div>

</div>